import { get, post, put, del } from './requests'

const resourcePath = 'labels'

export function listLabels () {
  return get(resourcePath).then(response => response.labels)
}

export function showLabel (id) {
  return get(`${resourcePath}/${id}`)
}

export function createLabel (data) {
  return post(`${resourcePath}`, { label: data })
}

export function updateLabel (data) {
  return put(`${resourcePath}/${data.id}`, { label: data })
}

export function deleteLabel (id) {
  return del(`${resourcePath}/${id}`)
}
